import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { SalarieCommonInfoDto } from "../../../dto/GenApi.iNotPaie.Dto/SalarieCommonInfoDto";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import moment from "moment";
import { EventBus } from "../../Controls/EventBus";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const image_mr = require("../../../assets/img_avatar_MR.png");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const image_mme = require("../../../assets/img_avatar_MME.png");

@Component
export default class CommonSalarieComponent extends Vue {
	public get currentId(): number {
		return parseInt(this.$route.params?.id);
	}

	public dataReady = true;
	public refreshData = false;
	public srcImage?: string = image_mr;
	public salarieCourant: SalarieCommonInfoDto = { Id: 0, IsCurrent: true };

	@Prop()
	public tab = 1;

	@Prop()
	public salarieCharges: salarieChargeInfos[] = [];

	public numeroTelFixe = "";
	public numeroTelMobile = "";

	public ancienneteNotariat = "";

	public mounted(): void {
    	this.refresh();
	}

	public setNumeroTel(val: string): void {
    	this.numeroTelFixe = "";
    	for (let i = 0; i < val.length; i++) {
    		this.numeroTelFixe += val[i];
    		if (i % 2 == 1 && i > 0) {
    			this.numeroTelFixe += " ";
    		}
    	}
	}

	public setNumeroPort(val: string): void {
    	this.numeroTelMobile = "";
    	for (let i = 0; i < val.length; i++) {
    		this.numeroTelMobile += val[i];
    		if (i % 2 == 1 && i > 0) {
    			this.numeroTelMobile += " ";
    		}
    	}
    }

	public refresh(): void {
    	this.fetchData();
	}

	public goToProfil(): void {
    	this.$emit("goToProfil");
	}

	public sendMail(): void {
    	const mail = this.salarieCourant.EMail != undefined ? this.salarieCourant.EMail : "";
    	window.location.href = "mailto:" + mail;
	}

	public resetData(id: number): void {
    	if (this.currentId == id) {
    		this.fetchData();
    	}
	}

	public refreshContrat(): void {
    	this.reloadData(this.currentId);
	}

	public reloadData(id: number): void {
    	this.resetData(id);
	}

	public fetchData(): void {
    	moment.updateLocale("fr", {
    		LocaleSpecification: {
    			future: "%s",
    			past: "%s",
    			s: (number: number) => {
    				return "00:" + (number < 10 ? "0" : "") + number + " minutes";
    			},
				ss: (number: number) => {
    				return "00:" + (number < 10 ? "0" : "") + number + " minutes";
    			},
    			m: "01:00 minutes",
				mm: (number: number) => {
    				return (number < 10 ? "0" : "") + number + ":00" + " minutes";
    			},
    			h: "1 heure",
    			hh: "%d heures",
    			d: "1 jour",
    			dd: "%d jours",
    			M: "un mois",
    			MM: "%d mois",
    			y: "une année",
    			yy: "%d années"
    		}
    	});
    	this.dataReady = false;
    	if (this.currentId > 0) {
			if (isNaN(Number(this.$route.query.idContrat))) {
				ServicesFactoryInstance.SalarieService.getSalarieCommonInfo(this.currentId, this.mapData, () => {
    				this.dataReady = true;
    			});
			} else {
				ServicesFactoryInstance.SalarieService.getSalarieCommonInfoFoContrat(this.currentId, Number(this.$route.query.idContrat), this.mapData, () => {
    				this.dataReady = true;
    			});
			}
    	} else {
    		this.dataReady = true;
    		this.srcImage = image_mr;
    		this.salarieCourant = { Id: 0, IsCurrent: true };
    		this.numeroTelFixe = "";
			this.numeroTelMobile = "";
			this.ancienneteNotariat = "";
    	}
	}

	public mapData(data: SalarieCommonInfoDto): void {
		if (data.Id != this.currentId) {
			return;
		}

    	this.dataReady = true;
    	this.salarieCourant = data;
    	if (this.salarieCourant.Photo != "") {
    		this.srcImage = this.salarieCourant.Photo;
    	} else if (this.salarieCourant.Civilite == "Monsieur") {
    		this.srcImage = image_mr;
    	} else {
    		this.srcImage = image_mme;
    	}
    	if (this.salarieCourant.NumeroTelMobile != undefined) {
			this.setNumeroPort(this.salarieCourant.NumeroTelMobile);
		} else {
			this.numeroTelMobile = "";
		}

    	if (this.salarieCourant.NumeroTelFixe != undefined) {
			this.setNumeroTel(this.salarieCourant.NumeroTelFixe);
		} else {
			this.numeroTelFixe = "";
		}

		if (this.salarieCourant.DateEntreeSalarie != undefined) {
			// Calcul de l'ancienneté dans le notariat
			const time = moment.utc(this.salarieCourant.DateEntreeSalarie).utc().toDate();
			const years = Math.floor(Math.floor(moment.utc(new Date()).diff(moment.utc(time, "MM/DD/YYYY"), "month", true)) / 12);
			const months = Math.floor(moment.utc(new Date()).diff(moment.utc(time, "MM/DD/YYYY"), "month", true)) % 12;
    		if (months < 0 || years < 0 || (months == 0 && years == 0)) {
    			this.ancienneteNotariat = "-";
    		} else if (years == 0) {
    			this.ancienneteNotariat = months + " mois";
    		} else {
    			this.ancienneteNotariat = years + " an(s) et " + months + " mois";
			}
    	} else {
			this.ancienneteNotariat = "-";
    	}
	}

	public navigueSalarie(idSalarie: number, nomPrenomSalarie: string): void {
		let tabAOuvrir: string;
    	if (this.salarieCharges != undefined &&
            this.salarieCharges[idSalarie] != undefined &&
            this.salarieCharges[idSalarie].isModified) {
    		// Si la page du salarié à afficher existe déjà et que son onglet est en cours de modification, on charge la page en restant sur son onglet.
    		tabAOuvrir = this.salarieCharges[idSalarie].tab.toString();
    	} else {
    		// Si la page du salarié à afficher n'existe pas ou n'est pas en cours de modification, on l'ouvre sur le même onglet que le salarié en cours.
    		tabAOuvrir = this.tab.toString();
    	}

    	EventBus.NavigateTo({ path: "/ficheSalarie/" + idSalarie, query: { titre: nomPrenomSalarie, onglet: tabAOuvrir } });
	}
}



// WEBPACK FOOTER //
// ./src/components/ficheSalarie/common/commonSalarie.ts